import React from 'react';
import { IAppState } from 'vev';
import NextClient from './client';
import { fetchURL } from './data-fetcher';

export type FetchProps = {
  state?: IAppState;
  pageKey?: string;
  projectKey?: string;
  dev?: boolean;
  noCache?: boolean;
};
export default function Fetch(props: FetchProps) {
  const notUseCache = process.env.NODE_ENV === 'development' || props.noCache;

  const url = `https://embed.vev.${props.dev ? 'space' : 'page'}/v1/${props.projectKey}/${
    props.pageKey
  }?type=json${notUseCache ? '&nocache' : ''}`;
  const { data, promise, resolved } = fetchURL<any>(url);
  if (!resolved) throw promise;

  if (!data) return null;

  return (
    <div style={{ position: 'relative' }}>
      <style dangerouslySetInnerHTML={{ __html: data?.css }} />
      <div dangerouslySetInnerHTML={{ __html: data?.html }} />
      <NextClient data={data.json} scripts={data.scripts} pageKey={props.pageKey || 'no-key'} />
    </div>
  );
}
